export const limitOptionsSelect = [
    {value: 15, label: '15'},
    {value: 50, label: '50'},
    {value: 100, label: '100'},
]

export const isActiveOptionsSelect = [
    {value: '-1', label: 'Все'},
    {value: '0', label: 'Не активно'},
    {value: '1', label: 'Активно'},
]

export const isSolvedOptionsSelect = [
    {value: '-1', label: 'Все'},
    {value: '0', label: 'Не решено'},
    {value: '1', label: 'Решено'},
    {value: '2', label: 'Системные'},
]

export const securityObjectOptions = [
    {value: 'GroupSchedule', label: 'Расписание группы'},
    {value: 'ObjectSchedule', label: 'Расписание объекта'},
    {value: 'Manual', label: 'Вручную'},
]

export const securityChangeModeOptions = [
    {value: 'MANUAL', label: 'Ручной'},
    {value: 'SCHEDULE', label: 'Расписание'},
    {value: 'DEVICE', label: 'Устройство'},
]

export const isAttachDeviceOptionsSelect = [
    {value: '-1', label: 'Все'},
    {value: '0', label: 'Не привязано'},
    {value: '1', label: 'Привязано'},
]